import { useCallback, useState } from 'react';

import useAccessToken from 'hooks/useAccessToken';
import useGlobalStore from 'hooks/useGlobalStore';
import useOrganizations from 'hooks/useOrganizations';

const useCurrentOrganization = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { getValue, setValue } = useGlobalStore({
        namespace: 'useCurrentOrganization'
    });

    const currentOrganization = getValue('currentOrganization');

    const { fetchOrganizations } = useOrganizations();
    const { fetchToken } = useAccessToken();

    const fetchCurrentOrganization = useCallback(async () => {
        setIsLoading(true);

        try {
            const organizations = await fetchOrganizations();

            if (organizations) {
                const mostRecentlyCreatedOrganization = [...organizations].sort(
                    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                )[0];

                setValue({ currentOrganization: mostRecentlyCreatedOrganization });

                if (mostRecentlyCreatedOrganization?.auth0Id) {
                    await fetchToken(mostRecentlyCreatedOrganization.auth0Id, false);
                }

                return mostRecentlyCreatedOrganization;
            }

            return null;
        } finally {
            setIsLoading(false);
        }
    }, [fetchOrganizations, setValue, fetchToken]);

    return {
        currentOrganization,
        fetchCurrentOrganization,
        isLoading
    };
};

export default useCurrentOrganization;
